import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import Styles from "../styles/main.module.css";
import { Breadcrumbs, Link, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import Loader from "../../../../Loader/Loader";
import { useStateValue } from "../../../../Hooks/stateProvider";
import { ls } from "../../../../variables";
import UploadAction from "../../../CommonLayouts/UploadAction";
import { encrypt } from "../../../../utils/cipher";
import ReadMore from "../../../CommonLayouts/ReadMore";
import { errorHandler } from "../../../../utils/errorHandling";
import { alert } from "../../../../utils/sweetAlert";
import { getDate } from "../../../../utils/getDate";

function Settlement() {
  
  const pmsname = ls.get("pmsName");
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: { maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP, width: 250 },
    },
  };


  const location = useLocation();
  const data = location.state;
  const [
    { moduleType, fy_year, quarter, fileName, fileDetails, alertDescription },
    dispatch,
  ] = useStateValue();
  const [pmsRTAComments, setpmsRTAComments] = useState("");
  const [proposedAction, setProposedAction] = useState("");
  const [startIndex, setStartIndex] = useState(0)
  const [endIndex, setEndIndex] = useState(50)
  const navigate = useNavigate();
  // const alertNo = data.alertno;
  // const [allInstID,setAllInstID] = useState(data.instanceID[0]);
  const alertPeriod = fy_year;
  const guidance = data.alertName;
  const ticketID = data.ticketID;
  const instanceCount = data.instanceCount
  const [selectedInstID, setSelectedInstID] = useState([]);


  const handleSubmit = async () => {
    if (pmsRTAComments == "") {
      alert("Please Enter Comments", "", "warning")
      return;
    }
    dispatch({ type: "SHOW_LOADER" });
    const date = getDate();
    const formData = new FormData();
    let payload = {
      fy_year: alertPeriod,
      quarter: quarter,
      pmsName: pmsname,
      ticketid: ticketID,
      guidancetype: guidance,
      instanceid: selectedInstID,
      noofinstances: instanceCount,
      updateFlag: true,
      status: "pending",
      moduleType: moduleType,
      userType: ls.get("userType"),
    };
    // console.log("pmsname settlementUpload",payload)
    if (ls.get("userType") == "RTA") {
      payload["remarks"] = {
        rtacomments: pmsRTAComments,
        proposedplanofaction: proposedAction,
        date: date
      }
    }
    else {
      payload["remarks"] = {
        pmscomments: pmsRTAComments,
        proposedplanofaction: proposedAction,
        date: date
      }
    }
    const encryptedFormData = await encrypt(payload);
    formData.append("file", fileDetails);
    formData.append("fileName", fileName);
    formData.append("payload", encryptedFormData);
    const encryptedHeaders = await encrypt({
      authtoken: ls.get("authToken"),
      refreshtoken: ls.get("refreshToken"),
    });
    axios
      .post("/api/pms/settlementUpload", formData, {
        headers: {
          headers: encryptedHeaders,
        },
      })
      .then((res) => {
        if (res.data.success) {
          // setAllInstID(allInstID.filter(removeElement => !selectedInstID.includes(removeElement)))
          // let remainingInstaIds = allInstID.length - selectedInstID.length;
          // console.log("The length",remainingInstaIds);
          setSelectedInstID([]);
          setpmsRTAComments("");
          setProposedAction("");
          // if(remainingInstaIds == 0){
          navigate("/app/upload");
          // }
          // setSubmitSuccessful(true);
          dispatch({ type: "HIDE_LOADER" });
          // navigate(-1);
          alert("Submitted Succesfully", "", "success")
        } else {
          alert("Unable to Submit", "", "error")
          dispatch({ type: "HIDE_LOADER" });
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        errorHandler(err, navigate)
      });
  };

  //  const handleSelectAll = () => {
  // const currentIDs = allInstID;
  //   if (currentIDs.every(id => selectedInstID.includes(id))) {
  //     setSelectedInstID(selectedInstID.filter(id => !currentIDs.includes(id)));
  //   } else {
  //     const newSelection = [...new Set([...selectedInstID, ...currentIDs])];
  //     setSelectedInstID(newSelection);
  //   }
  //   console.log("The selected instance id",selectedInstID);
  // };

  const handleSelect = (id) => {
    //if it is already available then remove, if not then add.
    if (selectedInstID.includes(id)) {
      setSelectedInstID(selectedInstID.filter(selectedId => selectedId !== id));
    } else {
      setSelectedInstID([...selectedInstID, id]);
    }
  };

  return (
    <>
      <Loader />
      <div
        className={Styles.FullBody}
        style={{ overflowX: "hidden", height: "95%" }}
      >
        <div className={Styles.navBody} style={{ width: "89%" }}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            {ls.get("userType") != "RTA" &&
              <Link
                underline="hover"
                color="inherit"
                onClick={() => navigate("/app/welcome")}
              >
                Welcome
              </Link>}
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate("/app/upload")}
            >
              Submission Page
            </Link>
            <Link
              underline="hover"
              color="inherit"
              onClick={() => navigate(-1)}
            >
              {guidance}
            </Link>
            <Link
              underline="hover"
              color="inherit"
            // href="/app/upload"
            >
              Form
            </Link>
          </Breadcrumbs>
        </div>
        <div
          className={`${Styles.Body} ${Styles.settlementBody}`}
          style={{ overflow: "auto", padding: "0.3rem" }}
        >
          <Paper
            elevation={3}
            style={{
              backgroundImage: "linear-gradient(#69B8F41A, #FFFFFF1A )",
              padding: "1rem 2rem 1.5rem 2rem",
              height: "85%",
              "::WebkitScrollbar": {
                display: "none",
              },
            }}
          >
            <Grid
              className={Styles.dataForm}
              container
              sx={{ display: "flex", height: "90%", overflowY: "auto" }}
              spacing={1}
            >
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    Alert Period
                  </p>
                  <input
                    id="alertPeriod"
                    style={{
                      border: "none",
                      borderBottom: "1px solid black",
                      outline: "none",
                      fontWeight: "400",
                      width: "70%",
                      fontSize: "1rem",
                      backgroundImage: "linear-gradient(#69B8F41A, #FFFFFF1A )",
                    }}
                    value={alertPeriod + ', ' + quarter}
                    readOnly
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    Ticket ID
                  </p>
                  <input
                    style={{
                      border: "none",
                      borderBottom: "1px solid black",
                      outline: "none",
                      fontWeight: "400",
                      width: "70%",
                      fontSize: "1rem",
                      backgroundImage: "linear-gradient(#69B8F41A, #FFFFFF1A )",
                    }}
                    value={ticketID}
                    readOnly
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    Guidance Type
                  </p>
                  <input
                    style={{
                      border: "none",
                      borderBottom: "1px solid black",
                      outline: "none",
                      fontWeight: "400",
                      width: "70%",
                      fontSize: "1rem",
                      backgroundImage: "linear-gradient(#69B8F41A, #FFFFFF1A )",
                    }}
                    value={guidance}
                    readOnly
                  />
                </Box>
              </Grid>

              {/* <Grid item xs={12} sm={6} md={4}> */}
              {/* <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "0.5rem",
                    }}
                  >
                    Instance ID
                  </p>
                  <div>
                    <FormControl
                      variant="standard"
                      sx={{ m: 0, height: "100%", width: "70%" }}
                    >
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        value={selectedInstID}
                        renderValue={(selected) => selected.join(", ")}
                        MenuProps={MenuProps}
                        style={{
                          fontWeight: "400",
                          width: "100%",
                          fontSize: "1rem",
                        }}
                      >
                        {startIndex > 0 && (
                          <MenuItem style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={() => {
                            setStartIndex(startIndex - 50)
                            setEndIndex(endIndex - 50)
                          }}>
                            Previous 50 Instance IDs
                          </MenuItem>
                        )}
                          <MenuItem style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={handleSelectAll}>
                            <Checkbox
                              // checked={allInstID .every(id => selectedInstID.includes(id))}
                            />
                            <ListItemText primary="Select All" />
                          </MenuItem>
                          {allInstID.slice(startIndex, endIndex).map((id,index) => (
                          <MenuItem key={id} value={id} onClick={()=>handleSelect(id)}>
                            <Checkbox
                              checked={selectedInstID.includes(id)}
                            />
                            <ListItemText primary={id} />
                          </MenuItem>
                        ))}
                        {allInstID.slice(startIndex, endIndex).length == 50 && (
                          <MenuItem style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={() => {
                            setStartIndex(startIndex + 50)
                            setEndIndex(endIndex + 50)
                          }}>
                            Next 50 Instance IDs
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </div>
                </Box> */}
              {/* </Grid> */}
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    No. of Instances
                  </p>
                  <input
                    style={{
                      border: "none",
                      borderBottom: "1px solid black",
                      outline: "none",
                      fontWeight: "400",
                      width: "70%",
                      fontSize: "1rem",
                      backgroundImage: "linear-gradient(#69B8F41A, #FFFFFF1A )",
                    }}
                    value={instanceCount}
                    readOnly
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    Annexure Description
                  </p>
                  <ReadMore text={alertDescription} maxLength={30} />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    {ls.get("userType") == "RTA" ? "RTA Comments" : "PMS Comments"}
                  </p>
                  <textarea
                    style={{
                      border: "1px solid black",
                      height: "4rem",
                      width: "85%",
                      outline: "none",
                      fontWeight: "400",
                      fontSize: "1rem",
                      resize: "none",
                      overflowY: "auto",
                    }}
                    value={pmsRTAComments}
                    onChange={(event) => {
                      setpmsRTAComments(event.target.value);
                    }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <Box>
                  <p
                    style={{
                      fontSize: "1rem",
                      marginTop: "1rem",
                      marginBottom: "1rem",
                    }}
                  >
                    Proposed Plan of Action
                  </p>
                  <textarea
                    style={{
                      border: "1px solid black",
                      height: "4rem",
                      width: "85%",
                      outline: "none",
                      fontWeight: "400",
                      fontSize: "1rem",
                      resize: "none",
                      overflowY: "auto",
                    }}
                    onChange={(event) => {
                      setProposedAction(event.target.value);
                    }}
                    value={proposedAction}
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                marginTop: "1rem",
              }}
            >
              <Grid
                item
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "2rem",
                }}
              >
                <div>
                  <UploadAction />
                </div>
                <div>
                  <button
                    className={`${Styles.Preview}`}
                    onClick={handleSubmit}
                  >
                    SUBMIT
                  </button>
                </div>
              </Grid>
            </Grid>
          </Paper>
        </div>
      </div>
    </>
  );
}

export default Settlement;
